import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useLocation, useNavigate } from 'react-router-dom';

import {  selectProfile } from './selector';
import { setAccessToken, setAuthenticated } from '../App/action';
import Header from '../../Components/Header';
import {logout, setLoginError} from '../../Pages/Login/action.js'
import { selectAccessToken, selectIsAuthenticated, selectRefreshToken } from '../App/selector';
import { connectWallet } from '../../Utils/blockchainHelper';
import { setWallet } from './action';
import {isTokenValid} from '../../Utils/JWT';
import LandingPage from '../../Pages/LandingPage';

const Client = ({ accessToken, refreshToken, isAuthenticated, children, profile }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const relogin = () => {
    dispatch(setLoginError('We are sorry, you need to signed in!'));
    navigate('/login');
  }
  const callbackWallet = () => {
    dispatch(setWallet(profile.connectedWallet));
  }
  useEffect(() => {
    if(!refreshToken || !accessToken || !isTokenValid(refreshToken)){
      if(location.pathname !== '/')
        dispatch(logout(relogin));
      else
        dispatch(setAccessToken(null));
    } else {
      if(accessToken){
        dispatch(setAuthenticated(true));
        connectWallet("check", callbackWallet);
      }
    }
},[location.pathname]);
  if(isAuthenticated)
    return <Header isAuthenticated={isAuthenticated} children={children} refreshToken={refreshToken}/>;
  else return <Header children={<LandingPage/>} />;
};

const mapStateToProps = createStructuredSelector({
  accessToken: selectAccessToken,
  refreshToken: selectRefreshToken,
  isAuthenticated: selectIsAuthenticated,
  profile: selectProfile
});

export default connect(mapStateToProps)(Client);
